import { useEffect, useRef } from "react";
import { pdfjs } from "react-pdf";
import { ensurePdfWorker } from "../UI/elements/pdfWorkerSetup";
import { fetchPdfBlob } from "../UI/elements/pdfBlobCache";

// Фоновая предзагрузка страниц для НЕвыбранных документов в EditManyDocs.jsx —
// нужна, чтобы цена по умолчанию считалась сразу для всех документов заказа
// (и чтобы кнопка оплаты включалась), а не только после того, как
// пользователь вручную откроет каждый документ (тогда docTotalPages/
// docRendered выставляет видимый DocumentViewer).
//
// Раньше здесь рендерился <Document file={url} options={{ httpHeaders }}>
// напрямую на удалённый URL — pdf.js сам ходил в сеть, полагаясь на свой
// внутренний httpHeaders-механизм для Authorization. Он не так надёжен, как
// обычный fetch (см. PdfView.jsx/DocView.jsx) и на проде молча не срабатывал:
// docTotalPages/docRendered для невыбранных документов никогда не
// выставлялись, и пользователю приходилось открывать каждый документ
// вручную, чтобы увидеть цену и разблокировать оплату. Теперь используется
// тот же надёжный fetch+Blob, что и у видимых вьюеров (общий кэш —
// pdfBlobCache.js: если пользователь потом откроет предзагруженный документ,
// повторного похода в сеть уже не будет), а подсчёт страниц идёт напрямую
// через pdfjs.getDocument() — без рендера <Document>/<Page>, здесь нужно
// только число страниц, а не картинка.
function PreloadDocumentPages({ fileUrl, onLoadSuccess }) {
    const accessToken = localStorage.getItem("access_token");

    // onLoadSuccess — инлайн-функция от родителя, пересоздаётся на каждый
    // рендер EditManyDocs.jsx; храним последнюю версию в ref, чтобы не
    // перезапускать fetch/парсинг ниже при каждом ре-рендере родителя.
    const onLoadSuccessRef = useRef(onLoadSuccess);
    useEffect(() => {
        onLoadSuccessRef.current = onLoadSuccess;
    }, [onLoadSuccess]);

    useEffect(() => {
        if (!fileUrl || !accessToken) return undefined;
        let cancelled = false;

        (async () => {
            try {
                await ensurePdfWorker();
                const blobUrl = await fetchPdfBlob(fileUrl, accessToken);
                if (cancelled) return;
                const pdf = await pdfjs.getDocument(blobUrl).promise;
                if (cancelled) return;
                onLoadSuccessRef.current(pdf.numPages);
            } catch (err) {
                console.error(`PreloadDocumentPages: не удалось предзагрузить ${fileUrl}`, err);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [fileUrl, accessToken]);

    return null; // Ничего не рендерит — только фоновый подсчёт страниц.
}

export default PreloadDocumentPages;
